import type { AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"
import type { SearchFiltersData, SearchRequest } from "../SearchFilters"
import type ProfessionalTypeKey from "mco-keys/src/t4/ProfessionalTypeKey"
import type SalutationKey from "mco-keys/src/t4/SalutationKey"
import ProfessionalBulkAddClient from "./Professional.BulkAdd.Client"

export type ProfessionalSearchEntry = {
	professionalId: number
	userId: string
	email: string
	salutationKey: SalutationKey
	firstName: string
	lastName: string
	professionalTypeKey: ProfessionalTypeKey
	treatmentCenterUuids: string[]
	conditionKeys: string[]
	gmcNumber?: string
	isLockedOut: boolean
	deleteDate?: string
}

type ProfessionalSearchResult = {
	professionals: ProfessionalSearchEntry[]
	total: number
}

class ProfessionalClient {
	constructor(private axiosClient: AxiosInstance) {
		this.bulkadd = new ProfessionalBulkAddClient(axiosClient)
	}

	private base = "/api/admin/professional"

	public bulkadd: ProfessionalBulkAddClient

	public getFilters = () =>
		handleQueryResult(
			this.axiosClient.get<SearchFiltersData>(`${this.base}/filters`)
		)

	public search = (request: SearchRequest) =>
		handleQueryResult(
			this.axiosClient.post<ProfessionalSearchResult>(
				`${this.base}/list`,
				request
			)
		)
}

export default ProfessionalClient
